import { StarrableFieldsFragment } from "components/engagement/star/graphql/StarrableFieldsFragment";
import IndicatorFieldsFragment from "components/financials/modern/graphql/fragments/IndicatorFieldsFragment";
import gql from "graphql-tag";

export default gql`
  fragment FinancialsTemplateFields on FinancialsTemplate {
    _id
    objectId
    createdAt
    lastUpdatedAt
    name
    description
    isNativeTemplate
    isFundamenteiTemplate
    isFundamenteiTeamTemplate
    vertical
    countryCode
    visibility
    templateCodes
    namespace
    createdBy {
      _id
      fullName
      isSiteAdmin
      pictureUrl
    }
    useCount
    deletedAt
    archivedAt
    indicators {
      ...IndicatorFields
    }
    ...StarrableFields
    viewerCanArchive
    viewerCanDelete
    viewerCanEdit
    viewerCanChangeVisibility
    viewerCanCopy
    overrideCriteria {
      forTemplateCodes
      forPlatformVertical
    }
  }

  ${IndicatorFieldsFragment}
  ${StarrableFieldsFragment}
`;
